/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 6/23/2023
 */
import React, { useState } from "react"
import labelsEN from "../../../../locales/en/translation.json"
import CreateNewOrgsModal from "./components/CreateNewOrgsModal"
import { Button, Fab, Stack } from "@mui/material"
import RefreshIcon from "@mui/icons-material/Refresh"
import { Tabs, Tab, Badge } from "react-bootstrap"
import AddIcon from "@mui/icons-material/Add"
import ApprovedOrgs from "./components/ApprovedOrgs"
import PendingOrgs from "./components/PendingOrgs"

const Organization = () => {
  const AUTO_APPROVE = localStorage.getItem("SET_AUTO_APPROVE")

  const [pendingCount, setPendingCount] = useState(0)
  const [isChange, setIsChange] = useState(false)
  const [isPendingChange, setIsPendingChange] = useState(false)
  const [updateData, setUpdateData] = useState(false)
  const [refreshKey, setRefreshKey] = useState(0)

  //modals state
  const [createModalOpen, setCreateModalOpen] = useState(false)

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
        <h1>{labelsEN.app_organization_page_title}</h1>
        <Stack direction="row" spacing={2} alignItems="center">
          <Button variant="outlined" startIcon={<RefreshIcon />} onClick={() => setRefreshKey((value) => value + 1)}>
            Refresh
          </Button>
        <Fab
          onClick={() => setCreateModalOpen(true)}
          color="success"
          variant="extended"
        >
          <AddIcon sx={{ mr: 1 }} />
          Create new
        </Fab>
        </Stack>
      </div>
      <br />
      <br />
      <div>
        <Tabs
          defaultActiveKey="Approved"
          id="uncontrolled-tab-example"
          className="mb-3"
        >
          <Tab eventKey="Approved" title={"Approved"}>
            <ApprovedOrgs
              refreshKey={refreshKey}
              updateData={updateData}
              setUpdateData={setUpdateData}
            />
          </Tab>
          {AUTO_APPROVE === "false" && (
            <Tab
              eventKey="Pending"
              title={
                <div>
                  Pending{" "}
                  {pendingCount !== 0 && (
                    <Badge bg="danger">{pendingCount}</Badge>
                  )}
                </div>
              }
            >
              <PendingOrgs
                refreshKey={refreshKey}
                updateData={updateData}
                setUpdateData={setUpdateData}
                setPendingCount={setPendingCount}
              />
            </Tab>
          )}
        </Tabs>
      </div>

      <CreateNewOrgsModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        setUpdateData={setUpdateData}
      />
    </div>
  )
}
export default Organization
